export const INTERNAL_EMAILS_DOMAINS = ['allos.co'];
